export const buttonIdsList = {
    uploadProjectClassification: 0,
    move: 0,
    logOut: 0,
    loadData: 0,
    updateAnnotation: 0,
    createSynthetic: 0,
    arsenal: 0,
    addNewInput: 0
};
export const MOCK_PROPS: {onClick: () => void, classNameButton:string, setButtonToBeEnableAfterPress:number, isDisabledActive:boolean} = {
    onClick: () => {},
    classNameButton: 'btn-main',
    setButtonToBeEnableAfterPress: 0,
    isDisabledActive: true
};
